import { doc, updateDoc } from 'firebase/firestore';
import { db, auth } from '../../../config/firebase';

/**
 * Updates a book's PDF URLs in Firestore
 * @param {string} bookId - The ID of the book to update
 * @param {object} pdfUrls - Object containing PDF URLs with keys: cover, verticalContent, horizontalContent
 * @returns {Promise<boolean>} - Success status
 */
export async function updateBookPdfUrls(bookId, pdfUrls) {
  try {
    const userId = auth.currentUser?.uid;
    if (!userId) {
      throw new Error('You must be logged in to update book PDF URLs');
    }

    if (!bookId) {
      throw new Error('Book ID is required');
    }

    // Create the update object with only the provided URLs
    const updateData = { updatedAt: new Date() };
    
    // Only include PDF URLs that are provided (not null or undefined)
    if (pdfUrls?.verticalContent) {
      updateData['pdfUrls.verticalContent'] = pdfUrls.verticalContent;
    }
    
    if (pdfUrls?.horizontalContent) {
      updateData['pdfUrls.horizontalContent'] = pdfUrls.horizontalContent;
    }
    
    if (pdfUrls?.cover) {
      updateData['pdfUrls.cover'] = pdfUrls.cover;
    }

    // Update the book document
    const bookRef = doc(db, 'books', bookId);
    await updateDoc(bookRef, updateData);
    
    console.log('Book PDF URLs updated:', bookId, updateData);
    return true;
  } catch (error) {
    console.error('Error updating book PDF URLs:', error);
    if (error.code === 'permission-denied') {
      throw new Error('You do not have permission to update this book. Please try logging in again.');
    }
    throw error;
  }
}
